import {
    doc,
    getDoc,
    setDoc,
    collection,
    getDocs,
    serverTimestamp,
} from "firebase/firestore";

import { auth, db } from "../firebase";
import { modules } from "../data/modules";

/**
 * Save progress for one activity
 */
export async function saveProgress(
    activityId,
    data = {}
) {

    const user = auth.currentUser;

    if (!user) return;

    await setDoc(

        doc(
            db,
            "users",
            user.uid,
            "progress",
            activityId
        ),

        {
            completed: true,
            completedAt: serverTimestamp(),

            lastPlayed: serverTimestamp(),

            attempts: 1,

            bestScore: null,

            score: null,

            ...data,

        },

        {
            merge: true,
        }

    );

}

/**
 * Load one activity
 */
export async function loadProgress(
    activityId
) {

    const user = auth.currentUser;

    if (!user) return null;

    const snapshot = await getDoc(

        doc(
            db,
            "users",
            user.uid,
            "progress",
            activityId
        )

    );

    if (!snapshot.exists())
        return null;

    return snapshot.data();

}

/**
 * Load all completed activities
 */
export async function loadAllProgress() {

    console.log("loadAllProgress()");
    console.log("currentUser =", auth.currentUser?.uid);

    const user = auth.currentUser;

    if (!user) {

        console.log("No user");
        return [];

    }

    const snapshot = await getDocs(

        collection(
            db,
            "users",
            user.uid,
            "progress"
        )

    );

    console.log(
        "Loaded progress docs:",
        snapshot.docs.length
    );

    return snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
    }));

}
/**
 * Number of completed activities
 */
export async function getCompletedCount() {

    const progress =
        await loadAllProgress();

    return progress.filter(
        activity => activity.completed
    ).length;

}

export async function getCompletedModuleCount() {

    const progress = await loadAllProgress();

    const completedIds = progress
        .filter(activity => activity.completed)
        .map(activity => activity.id);

    return modules.filter(module =>
        module.activities.every(activity =>
            completedIds.includes(activity.id)
        )
    ).length;

}